<br>
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Entregas</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="contenedor-form">
    <form [formGroup]="entregasGroup" (ngSubmit)="busqueda();" class="example-form">
      <div class="row">
        <div class="col s12 m12 l12">
            <label id="example-radio-group-label">Tipo Consulta</label><br>
            <mat-radio-group
              aria-labelledby="example-radio-group-label"
              class="example-radio-group"
              formControlName="tipoConsulta">
              <mat-radio-button class="example-radio-button" *ngFor="let tipoConsulta of tipoConsultaSrv" [value]="tipoConsulta.id">
                {{tipoConsulta.value}}
              </mat-radio-button>
            </mat-radio-group>
        </div>
      </div><br>
      <div class="row">
        <div class="col s12 m6 l2">
          <span *ngIf="loadingAgencias">
              <mat-spinner
              [diameter]="30"
              style="margin:0 auto; top:15px;"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingAgencias">
            <mat-form-field>
              <mat-label>AGENCIA</mat-label>
              <mat-select formControlName="idAgencia" (change)="cargarUsuariosAgencia();">
                <mat-option *ngFor="let agencia of agencias" [value]="agencia.id">
                  {{agencia.valor}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l4">
            <span *ngIf="loadingUsuarios">
                <mat-spinner
                [diameter]="30"
                style="margin:0 auto; top:15px;"
              ></mat-spinner>
            </span>
          <span *ngIf="!loadingUsuarios">
            <mat-form-field class="example-full-width">
                <input matInput placeholder="Transportador" [matAutocomplete]="auto" formControlName="usuarioCtrl">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let usuario of filteredUsuarios | async" [value]="usuario">                    
                    <span>{{usuario.valor}}</span>                 
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>
          </span>  
        </div>        
        <div class="col s12 m6 l2">
            <mat-form-field>
                <input formControlName="fechaInicial" readonly matInput [matDatepicker]="picker" placeholder="Fecha Inicial">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>              
        </div>
        <div class="col s12 m6 l2">
            <mat-form-field>
                <input formControlName="fechaFinal" readonly matInput [matDatepicker]="picker1" placeholder="Fecha Final">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>   
        </div>
        <div class="col s12 m6 l2">
            <button mat-raised-button color="accent" type="submit" [disabled]="!entregasGroup.valid || loading">Consultar</button>
        </div>
      </div>      
    </form>
  </div>
</mat-expansion-panel>
<br>
<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6 class="titulo-solicitud">Resultados</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    
    <div class="contenedor-form" *ngIf="loading">
        <mat-spinner
          [diameter]="100"
          style="margin:0 auto; top:15px;"
        ></mat-spinner>
      </div>

      <table
      
    [hidden]="!haveData"
    datatable
    [dtOptions]="dtOptions"
    [dtTrigger]="dtTrigger"
    class="display"
    style="width:100%"
  >
    <thead>
      <tr>        
        <th>Estado Entrega</th>
        <th>Sincronizado Operador</th>
        <th>En Ruta Operador</th>
        <th>Numero Documento</th>
        <th>Fecha De Cierre</th>
        <th>Código Entrega Pedido</th>
        <th>Orden SAP</th>
        <th>Entrega Salida</th>
        <th>Cliente</th>
        <th>Teléfono</th>
        <th>Dirección</th>
        <th>Ciudad</th>
        <th>Artículo</th>
        <th>Cantidad</th>
        <th>Tienda</th>
        <th>Fecha Entrega</th>
        <th>Ruta</th>
        <th>Cédula</th>
        <th>Placa</th>
        <th>Conductor</th>
        <th>Documento</th>
        <th>Foto</th>
        <th>Firma</th>        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of dataEntregas">        
        <td style="text-align: center;">
          <mat-icon *ngIf="item.idTpoNovedad == '1'" style="color: green;" [matTooltip]="item.TipoNovedad" matTooltipPosition="above">check_circle</mat-icon>
          <mat-icon *ngIf="item.idTpoNovedad == '2'" style="color: red;" [matTooltip]="item.TipoNovedad" matTooltipPosition="above">error</mat-icon>
          <mat-icon *ngIf="item.idTpoNovedad == '3'" style="color: orange;" [matTooltip]="item.TipoNovedad" matTooltipPosition="above">warning</mat-icon>
          <mat-icon *ngIf="item.idTpoNovedad == 'EN RUTA'" style="color: gray;" [matTooltip]="item.TipoNovedad" matTooltipPosition="above">local_shipping</mat-icon>
        </td>
        <td style="text-align: center;">
          <mat-icon *ngIf="item.sincronizado == 0" (click)="verDetalleWS(1, item.idServicioPaquete);" style="color: green; cursor: pointer;" matTooltip="PROCESADO" matTooltipPosition="above">check_circle</mat-icon>            
          <mat-icon *ngIf="item.sincronizado > 0" (click)="verDetalleWS(1, item.idServicioPaquete);" style="color: red; cursor: pointer;" matTooltip="ERROR" matTooltipPosition="above">error</mat-icon>          
          <mat-icon *ngIf="item.sincronizado == null" style="color: gray;" matTooltip="SIN PROCESAR" matTooltipPosition="above">error_outline</mat-icon>
        </td> 
        <td style="text-align: center;">
          <mat-icon *ngIf="item.enRutaOperador == 0" (click)="verDetalleWS(2, item.idServicioPaquete);" style="color: green; cursor: pointer;" matTooltip="INICIO" matTooltipPosition="above">check_circle</mat-icon>            
          <mat-icon *ngIf="item.enRutaOperador > 0" (click)="verDetalleWS(2, item.idServicioPaquete);" style="color: red; cursor: pointer;" matTooltip="ERROR" matTooltipPosition="above">error</mat-icon>          
          <mat-icon *ngIf="item.enRutaOperador == null" style="color: gray;" matTooltip="SIN INICIO" matTooltipPosition="above">error_outline</mat-icon>
        </td>      
        <td style="text-align: center;">{{ item.numeroDoc }}</td>  
        <td>{{ item.fechaNovedad }}</td>
        <td>{{ item.codigoEntregaPedido }}</td>
        <td>{{ item.ordensap }}</td>
        <td>{{ item.EntregaSalida }}</td>
        <td>{{ item.Cliente }}</td>
        <td>{{ item.Telefono }}</td>
        <td>{{ item.Direccion }}</td>
        <td>{{ item.Ciudad }}</td>
        <td>{{ item.Articulo }}</td>
        <td>{{ item.Cantidad }}</td>
        <td>{{ item.Tienda }}</td>
        <td>{{ item.fechaServicio | date:'yyyy-MM-dd'}}</td>
        <td>{{ item.Ruta }}</td>
        <td>{{ item.NroDocId }}</td>
        <td>{{ item.Placa }}</td>
        <td>{{ item.Conductor }}</td> 
        <td style="text-align: center;">
          <mat-icon style="cursor: pointer;" *ngIf="item.tieneDocumento>0" (click)="verDocumento(item.ordensap, item.idServicioEnc, 3);" color="accent" matTooltip="DOCUMENTO" matTooltipPosition="above">
            description
          </mat-icon>
          <mat-icon *ngIf="item.tieneDocumento==0" matTooltip="SIN DOCUMENTO" matTooltipPosition="above">
            not_interested
          </mat-icon>          
        </td> 
        <td style="text-align: center;">
          <mat-icon style="cursor: pointer;" *ngIf="item.tieneFoto>0" (click)="verDocumento(item.ordensap, item.idServicioEnc, 1);" color="accent" matTooltip="PRODUCTO" matTooltipPosition="above">
            photo
          </mat-icon>
          <mat-icon *ngIf="item.tieneFoto==0" matTooltip="SIN FOTO" matTooltipPosition="above">
              not_interested
          </mat-icon>
        </td> 
        <td style="text-align: center;">
          <mat-icon style="cursor: pointer;" *ngIf="item.tieneFirma>0" (click)="verDocumento(item.ordensap, item.idServicioEnc, 2);" color="accent" matTooltip="FIRMA" matTooltipPosition="above">
            fingerprint
          </mat-icon>
          <mat-icon *ngIf="item.tieneFirma==0" matTooltip="SIN FIRMA" matTooltipPosition="above">
              not_interested
            </mat-icon>
        </td>        
      </tr>
    </tbody>
  </table>
    
  </mat-expansion-panel>